module.exports = __webpack_public_path__ + "static/logo_inv-c92747940d8c60a632217ae9d1c851be.png";